/* global sepaExpress _satellite */
import { isAdobeSatelliteTrackingReady } from '../utils';

export default class SepaExpressService {
  errors;
  sepaExpressTimeoutInMillies;
  hppId;

  trackingDataLayer = [];
  isSepaExpressReady = false;
  isPopupCloseFromSepaSuccessOrErrorCallback = false;
  isTimedout = false;
  isOriginalWindowOpenfn = true;

  showErrorsAndMessages = window.showErrorsAndMessages;
  sepaExVariables = window.sepaExVariables;
  constructor() {
    if (this.sepaExVariables) {
      this.errors = this.sepaExVariables.errors;
      this.sepaExpressTimeoutInMillies =
        this.sepaExVariables.data.sepaExpressTimeoutInMillies;
      this.hppId = this.sepaExVariables.data.hppId;
    }
  }

  _setupSepaExpress = () => {
    sepaExpress.init(this.hppId);
    const sepaExpressTimeoutId = setTimeout(() => {
      this.isTimedout = true;
      if (!this.isSepaExpressReady) {
        document.querySelector('body').classList.remove('loading');
        this._showErrorMessage(true, this.errors.timeOut);
        window.addEventListener('load', () => {
          this._trackPaymentEvent({ type: 'SEPA_buy_button_timeout' });
        });
        this._removeSepaExpressContainer();
      }
    }, this.sepaExpressTimeoutInMillies);

    sepaExpress.ready(() => {
      this.isSepaExpressReady = true;
      this._setupMiddlewareForSepaWindowHandler();

      const stylingInterval = setInterval(() => {
        const sepaBtn = document.querySelector('#sepaExpressButton');
        if (sepaBtn) {
          document.querySelector('body').classList.remove('loading');
          this._styleAsKaufenButton(sepaBtn);
          this._setupTrackingForSepaExButton();
          clearInterval(stylingInterval);
        }
      }, 100);

      if (!this.isTimedout) {
        clearTimeout(sepaExpressTimeoutId);
      }
    });

    return new Promise((resolve, reject) => {
      sepaExpress.finish(function (message) {
        resolve(message);
      });
      sepaExpress.error(function (error) {
        reject(error);
      });
    });
  };

  _removeSepaExpressContainer() {
    document.querySelector('#sepa-express-container').remove();
  }

  _updateAndSubmitForm(mandateId) {
    const hiddenInput = document.querySelector('#sepaMandateId');
    //set form hidden value to mandateId
    hiddenInput.value = mandateId;
    // submit form
    document.querySelector('#js-placeOrderForm').submit();
  }

  _styleAsKaufenButton(btnElement) {
    window.requestAnimationFrame(() => {
      btnElement.classList.remove('btn');
      btnElement.classList.add(
        'z-btn',
        'z-btn--cart',
        'full__width__btn',
        'js-placeOrderBtn',
        'place-order-btn'
      );
      btnElement.style = '';
    });
  }

  //this sets up a middleware to intercept sepaexpress js call to window.open to have a reference to the opened sepa express popup
  _setupMiddlewareForSepaWindowHandler = () => {
    if (this.isOriginalWindowOpenfn) {
      const originalWindowOpenFn = window.open;
      window.open = (...args) => {
        this._showErrorMessage(false);
        this.isPopupCloseFromSepaSuccessOrErrorCallback = false;
        const sepaPopUpWindow = originalWindowOpenFn(...args);
        let didWindowClose = false;
        let isImpressionTracked = false;
        //this reliably checks whether the sepa express pop up is closed
        const sepaWindowStateTrackerTimer = setInterval(() => {
          if (sepaPopUpWindow.closed) {
            //if the window is closed wait for the next tick , such that in case of an accepted close, success and error callback can be handled first
            if (didWindowClose) {
              this._showSepaWindowCloseError();
              this._trackPaymentEvent({ type: 'Bank_popup_close' });
              clearInterval(sepaWindowStateTrackerTimer);
            }
            didWindowClose = !didWindowClose;
          }
          if (!sepaPopUpWindow.closed && !isImpressionTracked) {
            this._trackPaymentEvent({ type: 'Bank_popup_impression' });
            isImpressionTracked = true;
          }
        }, 500);
        return sepaPopUpWindow;
      };
      this.isOriginalWindowOpenfn = false;
    }
  };

  _showSepaWindowCloseError = () => {
    if (!this.isPopupCloseFromSepaSuccessOrErrorCallback) {
      this._showErrorMessage(true, this.errors.bankConnection);
    }
  };

  _showErrorMessage = (show, message) => {
    window.requestAnimationFrame(() => {
      if (show) {
        document.querySelector(
          '.sepa-express-content-error-container .info__text p:first-child'
        ).innerText = message;
        document.querySelector('.sepa-express-content-error-container').style =
          'display: block;';
      } else {
        document.querySelector('.sepa-express-content-error-container').style =
          'display: none;';
      }
    });
  };

  _setupTrackingForSepaExButton = () => {
    document
      .querySelector('#sepaExpressButton')
      .addEventListener('click', () => {
        this._trackPaymentEvent({ type: 'click_buy' });
      });
  };

  _trackPaymentEvent(eventPayload) {
    if (isAdobeSatelliteTrackingReady()) {
      _satellite.track('payment_tracking', eventPayload && eventPayload);
    }
  }
  _redirectToEditPaymentPage() {
    window.location.replace(
      window.location.origin + '/checkout/editpayment?verification=failed'
    );
  }

  init = () => {
    if (sepaExpress) {
      this._setupSepaExpress()
        .then((message) => {
          this.isPopupCloseFromSepaSuccessOrErrorCallback = true;
          this._showErrorMessage(false);
          this._removeSepaExpressContainer();
          this._updateAndSubmitForm(message.reference);
        })
        .catch((error) => {
          //handle errors here;
          this.isPopupCloseFromSepaSuccessOrErrorCallback = true;
          this._removeSepaExpressContainer();
          if (error.reasonCode === 'SPX 704' || !error.reasonCode) {
            this._showErrorMessage(true, this.errors.bankConnection);
            this._trackPaymentEvent({ type: 'IBAN_verif_fail' });
          } else {
            this._redirectToEditPaymentPage();
            this._trackPaymentEvent({ type: 'IBAN_verif_bank_details' });
          }
        });
    }
  };
}
